import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from 'src/app/reducers';
import { UserAssessment } from 'src/app/store/assessment/assessment.models';

@Component({
  selector: 'app-instruction',
  templateUrl: './instruction.component.html',
  styleUrls: ['./instruction.component.scss'],
})
export class InstructionComponent implements OnInit, OnDestroy {
  private destroyer$: Subject<any> = new Subject();

  assessment: UserAssessment = null;
  pageReady: boolean = false;
  errorMessage: string = null;

  constructor(private store: Store<State>, private router: Router) {
    this.store.select(state => state.assessments.currentUserAssessment).pipe(takeUntil(this.destroyer$)).subscribe(t => {
      if (t) {
        this.assessment = t;
        this.pageReady = true;
      } else {
        this.router.navigate(['/assessments']);
      }
    });
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroyer$.next(false);
    this.destroyer$.complete();
  }
}
